export function shortWallet(value) {
if(value === null) { return ''; }

return (`${value.slice(0, 6)}...${value.slice(-4, value.length)}`)
}